export default "__VITE_ASSET__CvUxj_2Y__"